import React, { useState } from 'react';
import { StyleSheet, View, Text, TouchableOpacity, Dimensions } from 'react-native';
import { Color, globalFontStyle, Font } from '../../../assets';
import Colors from '../../../assets/Color/Colors';
import withLiveData from '../../../common/withLiveData';
import {
  currencyConverter,
  giveCorrectPrice,
  isMobile,
} from '../../../utils/commonMethods';
import { RUPEE_ICON } from '../../../utils/constants';
import { tip_image, volume, defaulteventimage } from '../../../utils/images';
import { getSubcategoryImage } from '../../../utils/subcategoryImages';
import TimerComp from '../../../commonComponents/TimerComp';
import FastImage from '../../../common/FastImage';
import { Image } from 'expo-image';
import HomeBuySellComp from './HomeBuySellComp';
import { globalImport } from '../../../common/globalImports';
import FormTextLabel from '../../../commonComponents/FormTextLabel';
import {
  globalConfigurableData,
  GlobalScreens,
} from '../../../utils/globalConstant';
import { TradingButtons } from '../../../components/core/Button/TradingButtons';



const TradeCard = props => {
  const {
    trade,
    live = null,
    onBtnPress,
    isContestCard,
    timerExpireCallback = () => { },
  } = props;

  const t = trade;
  let yPrice = live?.newYCP ?? t?.newYCP;
  let nPrice = live?.newNCP ?? t?.newNCP;

  // Updated getImage function to use subcategory images
  const getImage = () => {
    return t?.imageurl || getSubcategoryImage(t?.subcategory) || defaulteventimage();
  };

  // Get screen width
  const screenWidth = Dimensions.get('window').width;

  // Calculate image size based on screen width - smaller sizes
  const getImageSize = () => {
    if (screenWidth < 768) { // mobile
      return 65;
    } else if (screenWidth < 1024) { // tablet
      return 55;
    } else { // web
      return 65;
    }
  };

  const imageSize = getImageSize();

  return (
    <View>
      <View
        style={[
          styles.cardContainer,
          GlobalScreens.Home?.mCardBorder
            ? { borderColor: GlobalScreens.Home?.mCardBorder }
            : {},
          isMobile() && styles.mobileCardContainer
        ]}>
        <View style={[
          { minHeight: 115, justifyContent: 'space-between' },
          isMobile() && styles.mobileInnerContainer
        ]}>
          <View style={[styles.upperRow, isMobile() && styles.mobileUpperRow]}>
            <View style={styles.imageContainer}>
              <Image
                style={[
                  styles.cardImg,
                  { width: imageSize, height: imageSize },
                  isMobile() && styles.mobileCardImg
                ]}
                source={getImage()}
                contentFit="cover"
                transition={1000}
              />
              <TimerComp
                end_time={t?.endsat}
                isHome={'home'}
                timerExpireCallback={timerExpireCallback}
                customStyle={{
                  position: 'absolute',
                  bottom: t?.probe_type === 'promo' ? 24 : 0,
                  left: 0,
                  right: 0,
                  backgroundColor: '#FF3B30',
                  paddingVertical: 6,
                  alignItems: 'center',
                  justifyContent: 'center',
                  borderBottomLeftRadius: t?.probe_type === 'promo' ? 0 : 4,
                  borderBottomRightRadius: t?.probe_type === 'promo' ? 0 : 4,
                  flexDirection: 'row',
                  isStrip: true,
                  marginTop: 0,
                  marginBottom: 0,
                  marginHorizontal: 0,
                  borderTopWidth: 0,
                }}
              />
              {t?.probe_type === 'promo' && (
                <View style={styles.smileCoinBlk}>
                  <Image
                    source={require('../../../assets/images/fantasy_selected.webp')}
                    style={styles.fantasyIcon}
                    contentFit="contain"
                  />
                </View>
              )}
            </View>
            <View style={[styles.contentContainer, isMobile() && styles.mobileTextContainer]}>
              <View style={styles.titleContainer}>
                <Text
                  style={[
                    globalFontStyle.appFontHeading,
                    {
                      color: globalConfigurableData.primaryTextColor1,
                      flexWrap: 'wrap',
                      flex: 1,
                      marginRight: 16,
                      ...(isMobile() && {
                        fontSize: Font.fontSize16,
                        lineHeight: 22,
                      }),
                    },
                  ]}
                  numberOfLines={2}>
                  {t?.title}
                </Text>
                {t?.subtitle && t?.subtitle.trim() && (
                  <Text
                    style={[
                      globalFontStyle.appFontHeadingSubtitle,
                      { 
                        color: globalConfigurableData.primaryTextColor1, 
                        marginTop: 4,
                        ...(isMobile() && {
                          fontSize: Font.fontSize16,
                          lineHeight: 22,
                        }),
                      },
                    ]}
                    numberOfLines={1}>
                    {t?.subtitle}
                  </Text>
                )}
              </View>
            </View>
          </View>

          <View style={styles.bottomRow}>
            {t.parent_id !== -1 ? (
              <TradingButtons
                yesPrice={giveCorrectPrice({ yPrice: yPrice })}
                noPrice={giveCorrectPrice({ nPrice: nPrice })}
                onPress={onBtnPress}
                disabled={isContestCard}
                isEvent={false}
                className="card-button"
              />
            ) : (
              <View style={styles.multiContainerStyle}>
                <FormTextLabel
                  labelStyles={{
                    color: Color.lightgrey,
                    ...globalFontStyle.appFontSubText,
                    marginRight: 5,
                  }}
                  label={'+ more options'}
                  rest={{ responseMultiEvents: t?.sub_events_titles?.length }}
                />
              </View>
            )}
          </View>
        </View>
      </View>
    </View>
  );
};

const getEventId = props => props?.trade?.id;
export default withLiveData(getEventId)(TradeCard);

const styles = StyleSheet.create({
  cardImg: {
    borderRadius: 4,
    overflow: 'hidden',
  },
  volStyle: {
    width: 17,
    height: 17,
    marginRight: 5,
  },
  cardContainer: {
    borderColor: GlobalScreens.Event.borderColor,
    backgroundColor: globalConfigurableData.cardBgColor,
    //elevation: 2,
    marginTop: isMobile() ? 15 : 20,
  },
  upperRow: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 20,
  },
  bottomRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 10,
  },
  multiContainerStyle: {
    borderRadius: 100,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: Colors.yesColorInactive,
    borderColor: Colors.yesColor,
    borderWidth: 0.5,
    paddingHorizontal: 20,
    paddingVertical: 6,
  },
  tipContainer: {
    borderBottomLeftRadius: 8,
    borderBottomRightRadius: 8,
    backgroundColor: GlobalScreens.Event.tipBackgroundColor,
    paddingVertical: 8,
    paddingHorizontal: 15,
    marginTop: 20,
    marginBottom: -15,
    marginHorizontal: -15,
    flexDirection: 'row',
    justifyContent: 'center',
  },
  tipTextBlock: {
    borderTopRightRadius: 8,
    borderBottomRightRadius: 8,
    backgroundColor: Colors.bgWhite,
    paddingHorizontal: 6,
    paddingVertical: 2,
    marginRight: 7,
  },
  cardBtn: {
    backgroundColor: GlobalScreens?.Home.yesBtnBlock,
    flex: 1,
    paddingHorizontal: 16,
    paddingVertical: 8,
    alignItems: 'center',
    flexDirection: 'row',
    borderRadius: 4,
    justifyContent: 'center',
  },
  smileCoinBlk: {
    position: 'absolute',
    left: 0,
    right: 0,
    bottom: 0,
    paddingVertical: 4,
    backgroundColor: globalConfigurableData.primaryBtnColor,
    borderBottomLeftRadius: 4,
    borderBottomRightRadius: 4,
    alignItems: 'center',
    justifyContent: 'center',
    ...(isMobile() && {
      paddingVertical: 2,
    }),
  },
  fantasyIcon: {
    width: isMobile() ? 16 : 20,
    height: isMobile() ? 16 : 20,
  },
  smileCoinText: {
    color: globalConfigurableData.globalThemeColor,
    fontSize: isMobile() ? Font.fontSize10 : Font.fontSize12,
    letterSpacing: 0.2,
    textAlign: 'center',
  },
  chancesContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minWidth: 50,
    alignSelf: 'center',
  },
  chancesText: {
    color: globalConfigurableData.primaryTextColor1,
    fontSize: 20,
    fontWeight: '400',
    minWidth: 50,
    textAlign: 'right',
  },
  mobileCardContainer: {
  },
  mobileInnerContainer: {
    minHeight: 100,
  },
  mobileUpperRow: {
    marginBottom: 12,
  },
  mobileCardImg: {
    borderRadius: 4,
  },
  mobileTextContainer: {
    marginLeft: 16,
  },
  contentContainer: {
    flex: 1,
    marginLeft: 16,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  titleContainer: {
    flex: 1,
  },
  imageContainer: {
    position: 'relative',
  },
  timerStrip: {
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
    backgroundColor: '#FF3B30',
    paddingVertical: 4,
    alignItems: 'center',
    justifyContent: 'center',
    borderBottomLeftRadius: 4,
    borderBottomRightRadius: 4,
  },
  timerText: {
    color: '#FFFFFF',
    fontSize: Font.fontSize12,
    fontWeight: '600',
    letterSpacing: -0.04,
  },
});
